module.exports = __webpack_public_path__ + "static/media/img15.a12a26b4.jpg";